import { render, staticRenderFns } from "./theme.page.vue?vue&type=template&id=2a7934c8&scoped=true&"
import script from "./theme.page.vue?vue&type=script&lang=js&"
export * from "./theme.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7934c8",
  null
  
)

export default component.exports